var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { getType } from "typesafe-actions";
import * as user from "./actions";
export var initialState = {
  accessToken: "",
  userQuizState: null
};
export var userReducer = function userReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(user.set):
      return action.payload;

    case getType(user.setToken):
      return __assign(__assign({}, state), {
        accessToken: action.payload
      });

    case getType(user.setQuizState):
      return __assign(__assign({}, state), {
        userQuizState: action.payload.userQuizState
      });

    case getType(user.clear):
      return initialState;

    default:
      return state;
  }
};